import type { CareTeamProvider } from '@ehr/shared';
import { api } from './api.js';
import { useFetch } from './useFetch.js';

/**
 * ehr#232 - the practice's providers: active users who answered "Yes, they see clients"
 * (GET /providers/directory, open to every signed-in user). Every EHR provider picker reads
 * this list rather than the whole team, so support staff (front desk, billing, admin) are
 * never offered as a clinician.
 */
export function useProviders() {
  return useFetch<CareTeamProvider[]>(() => api.get('/providers/directory'), []);
}

/** A provider's name for a picker. */
export const providerName = (p: Pick<CareTeamProvider, 'display' | 'email'>) =>
  p.display || p.email;
